import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import label from "../labels/statisticalReport_en.json";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import commonLabels from "../../common/labels/common_en.json";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getYearList,
  getAdvertisementlistByYear,
} from "../../common/actions/commonActions";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
  getPostCriteriaByAdvertisementId,
  getPostCriteriaByExamId,
  getSubjectlistByExamId,
} from "../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import {
  getPostCriteriaStatisticsData,
  getStatisticsData,
  getmainExamResultAdvertByYearId,
  getpreExamResultAdvertByYearId,
} from "../actions/statisticalReportActions";
import {
  GET_POST_CRITERIA,
  GET_STATISTICALDATA,
} from "../../common/constants/ActionTypes";
import { GET_STATISTICAL_DATA } from "../../common/constants/endpoints";

const Statistics = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [saveDataButtonFlag, setSaveDataButtonFlag] = useState(true);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [confirmClicked, setConfirmClicked] = useState(true);
  const [printFlag, setPrintFlag] = useState(true);
  const [prePrintFlag, setPrePrintFlag] = useState(true);
  const [stepName, setName] = useState("PreExamResult");
  const [pdfPrintDisabled, setPdfPrintDiabled] = useState(false);
  //   const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedPostCriteria, setSelectedPostCriteria] = useState("");
  const session = JSON.parse(sessionStorage.getItem("session"));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0);
    dispatch({
      payload: {},
      type: GET_STATISTICALDATA,
    });
    setReloadItem(!reloadItem);
  }, []);
  useEffect(() => {
    if (stepName === "PreExamResult") {
      reset();
      setSaveDataButtonFlag(true);
      setPrePrintFlag(true);
      dispatch({
        type: GET_POST_CRITERIA,
        payload: {},
      });
      setReloadItem(!reloadItem);
    }
    if (stepName === "MainExamResult") {
      reset();
      setSaveButtonFlag(true);
      setPrintFlag(true);
      dispatch({
        type: GET_STATISTICALDATA,
        payload: {},
      });
      setReloadItem(!reloadItem);
    }
  }, [stepName]);

  let { advertisementList, examList, subjectList, postcriterialisting } =
    useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  let {
    getstatisticaldata,
    getPostCriteriaData,
    getpreexamAdvertbyYear,
    getmainExamAdvertbyYear,
  } = useSelector((state) => state.statisticalReducer, shallowEqual);

  const statisticalTable = [
    {
      label: label.TotalAdmittedCandidates,
      data: getstatisticaldata.admittedCandidates,
    },
    {
      label: label.Absent,
      data: getstatisticaldata.absentCandidates,
    },
    { label: label.Present, data: getstatisticaldata.presentCandidates },
    {
      label: label.NotEligibleLessPercentileMarks,
      data: getstatisticaldata.notEligibleLessPercentileMarks,
    },
    {
      label: label.EligibleForGeneralFemaleSlab,
      data: getstatisticaldata.eligibleForGeneralFemaleSlab,
    },
    {
      label: label.EligibleOnlyforSportsorPHslab,
      data: getstatisticaldata.eligibleOnlyForSportsOrPHSlab,
    },

    { label: label.EligibleForSlab, data: getstatisticaldata.eligibleForSlab },
    {
      label: label.QualifiedCandidates,
      data: getstatisticaldata.qualifiedCandidates,
    },
  ];
  const statisTable = [
    {
      label: label.TopperMarks,
      data: getstatisticaldata.toppersMarks,
    },
    {
      label: label.thirtyfivePercentile,
      data: getstatisticaldata.percentile35,
    },
    {
      label: label.thirtyPercentile,
      data: getstatisticaldata.percentile30,
    },
    {
      label: label.twentyPercentile,
      data: getstatisticaldata.percentile20,
    },
  ];

  const PreExamResult = [
    {
      label: label.totalAdmittedCandidate,
      data: getPostCriteriaData?.totalAdmittedCandidates,
    },
    {
      label: label.PostCriteriaCount,
      data: getPostCriteriaData?.postCriteriaCount,
    },
    {
      label: label.PresentCandidate,
      data: getPostCriteriaData?.presentCandidates,
    },
    {
      label: label.notEligibleabsent,
      data: getPostCriteriaData?.notEligibleAbsent,
    },
    {
      label: label.notEligiblemarkslessthanone,
      data: getPostCriteriaData?.notEligibleMarksLessThanOne,
    },
    { label: label.eligibleslab, data: getPostCriteriaData?.eligibleForSlab },
    {
      label: label.qualifiedCandidate,
      data: getPostCriteriaData?.qualifiedCandidates,
    },
  ];
  const onSelectYear = (ele) => {
    let selectedValue = ele;
    setSelectedYear(selectedValue);
    if (stepName == "PreExamResult") {
      selectedValue && dispatch(getpreExamResultAdvertByYearId(selectedValue));
      dispatch({
        type: GET_POST_CRITERIA,
        payload: {},
      });
    }
    if (stepName == "MainExamResult") {
      if (selectedValue) {
        dispatch(getmainExamResultAdvertByYearId(selectedValue));
      }
    }
    if (allYearList) {
      allYearList.length = 0;
    }
    if (examList) {
      examList.length = 0;
    }
    if (postcriterialisting) {
      postcriterialisting.length = 0;
    }
    setSaveButtonFlag(true);
    setSaveDataButtonFlag(true);
    setPrePrintFlag(true);
    setPrintFlag(true);
    dispatch({
      type: GET_STATISTICALDATA,
      payload: {},
    });
    setReloadItem(!reloadItem);
  };

  const onAdvertisementChange = (ele) => {
    setSelectedAdvertNo(ele);
    setSelectedExam("");
    setSaveButtonFlag(true);
    setSaveDataButtonFlag(true);
    setConfirmClicked(true);
    setPrintFlag(true);
    setPrePrintFlag(true);
    examList.length = 0;
    if (postcriterialisting) {
      postcriterialisting.length = 0;
    }
    setSelectedPostCriteria("");
    if (stepName == "PreExamResult") {
      if (ele) {
        dispatch(getExamslistByAdvertisementId(ele));
        dispatch(getPostCriteriaByAdvertisementId(ele));
        dispatch({
          type: GET_POST_CRITERIA,
          payload: {},
        });
      }
    }
    if (stepName == "MainExamResult") {
      if (ele) {
        dispatch(getExamslistByAdvertisementId(ele));
        dispatch(getPostCriteriaByAdvertisementId(ele));
      }
    }
    dispatch({
      type: GET_STATISTICALDATA,
      payload: {},
    });
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    setSelectedExam(ele);
    if (stepName === "MainExamResult") {
      setSaveButtonFlag(false);
    } else if (stepName === "PreMainResult") {
      setSaveDataButtonFlag(true);
      setPrePrintFlag(true);
      dispatch({
        type: GET_POST_CRITERIA,
        payload: {},
      });
    }
    setPrintFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);

    dispatch({
      type: GET_STATISTICALDATA,
      payload: {},
    });
    setReloadItem(!reloadItem);
  };

  const onPostCriteriaChange = (ele) => {
    setSelectedPostCriteria(ele);

    setSaveDataButtonFlag(false);
    // setPrintFlag(true);
    setConfirmClicked(false);
    if (stepName === "PreMainResult") {
      dispatch({
        type: GET_POST_CRITERIA,
        payload: {},
      });
    }
    dispatch({
      type: GET_STATISTICALDATA,
      payload: {},
    });
    setReloadItem(!reloadItem);
  };

  const onCancelButton = () => {
    // setSelectedAdvertNo("");
    // setSelectedExam("");
    // setSelectedPostCriteria("");
    reset();
    setSaveButtonFlag(true);
    setSaveDataButtonFlag(true);
    setConfirmClicked(true);
    setPrintFlag(true);
    setReloadItem(!reloadItem);
    examList.length = 0;
    subjectList.length = 0;

    dispatch({
      type: GET_POST_CRITERIA,
      payload: {},
    });

    dispatch({
      type: GET_STATISTICALDATA,
      payload: {},
    });
  };

  const onSubmit = (e) => {
    if (stepName === "PreExamResult") {
      dispatch(
        getPostCriteriaStatisticsData(
          selectedAdvertNo,
          selectedExam,
          selectedPostCriteria,
          setPrePrintFlag
        )
      );

      setPrePrintFlag(false);
      setSelectedYear("");
    } else if (stepName === "MainExamResult") {
      dispatch(getStatisticsData(selectedAdvertNo, selectedExam, setPrintFlag));
      setPrintFlag(false);
      // setReloadItem(!reloadItem);
    }
    // setPrintFlag(false);
    setReloadItem(!reloadItem);
  };

  const downloadPdf = () => {
    if (stepName === "PreExamResult") {
      setSaveDataButtonFlag(true);
      setPrePrintFlag(false);
      if (pdfRef) {
        genPdf();
        // setPrintFlag(true)
      }
    } else if (stepName === "MainExamResult") {
      setSaveButtonFlag(true);
      setPrintFlag(false);
      if (pdfRef) {
        genPdf();
      }
    }
    setPdfPrintDiabled(false);
    setReloadItem(!reloadItem);
  };


  const genPdf = () => {
    const htmlContent = document.createElement("div");

    htmlContent.innerHTML =
      '<div class="row d-flex flex-column align-items-center"><h5>' +
      commonLabels.MPSC +
      "</h5><h5>" +
      (getPostCriteriaData && getPostCriteriaData.advertisementName
        ? getPostCriteriaData.advertisementName
        : " ") +
      "</h5><h5>" +
      (getstatisticaldata && getstatisticaldata.examName
        ? getstatisticaldata.examName
        : getPostCriteriaData && getPostCriteriaData.examName
          ? getPostCriteriaData.examName
          : "") +
      "</h5><h5>" +
      label.Statistics +
      "</h5></div>";
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [1, 0.3, 0.5, 0.3],
      filename: "Statistical.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1.2;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");

          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth - 0.2;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad =
            (getstatisticaldata && getstatisticaldata.advertisementNo) ||
            (getPostCriteriaData && getPostCriteriaData.advertisementNo) ||
            "";
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        {
          (getstatisticaldata.advertisementNo &&
            pdf.save(`MainExamResult Statistics.pdf`)) ||
            (getPostCriteriaData.advertisementNo &&
              pdf.save(`PreExamResult Statistics.pdf`));
        }
      });
  };

  return (
    <div>
      {/* <h5> {label.Statistics} </h5> */}
      <div
        className="tab-content border border-light"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "PreExamResult"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="PreExamResult"
              id="PreExamResult-tab"
              onClick={() => setName("PreExamResult")}
              data-toggle="tab"
              role="tab"
              aria-controls="PreExamResult"
              aria-selected="false"
            >
              <span>{label.PreExamResult}</span>
            </a>
          </li>
          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "MainExamResult"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="MainExamResult"
              id="unapproved-tab"
              onClick={() => setName("MainExamResult")}
              data-toggle="tab"
              role="tab"
              aria-controls="MainExamResult"
              aria-selected="false"
            >
              <span>{label.MainExamResult}</span>
            </a>
          </li>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "PreExamResult"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="PreExamResult"
            role="tabpanel"
            aria-labelledby="PreExamResult-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList.map((element, index) => (
                              <option>{element}</option>
                            ))}
                        </select>
                        {_.get("selectedYear.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>

                      <div className="form-group col-md-4">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {getpreexamAdvertbyYear &&
                            getpreexamAdvertbyYear.length > 0 &&
                            getpreexamAdvertbyYear
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>

                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedExam.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>

                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.PostCriteria}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedPostCriteria"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onPostCriteriaChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {postcriterialisting &&
                            postcriterialisting.length > 0 &&
                            postcriterialisting
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedPostCriteria.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-8">
                        {(session.roleName == "superadmin" ||
                          session.roleName == "secretary" ||
                          session.roleName == "desk officer") && (
                            <>
                              {" "}
                              <button
                                type="reset"
                                className="btn btn-secondary mr-2"
                                onClick={() => onCancelButton()}
                              >
                                {commonLabels.BUTTON_CANCEL}
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                disabled={saveDataButtonFlag}
                                onClick={(e) => {
                                  onSubmit(e);
                                  setConfirmClicked(true);
                                }}
                              >
                                {commonLabels.BUTTON_VIEW}
                              </button>
                            </>
                          )}
                        {(session.roleName == "superadmin" ||
                          session.roleName == "secretary") && (
                            <button
                              type="button"
                              className="btn btn-primary mr-2"
                              disabled={prePrintFlag || pdfPrintDisabled || !getPostCriteriaData.totalAdmittedCandidates}
                              onClick={() => {
                                downloadPdf();
                              }}
                            >
                              {commonLabels.BUTTON_PRINT}
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {getPostCriteriaData &&
              getPostCriteriaData.totalAdmittedCandidates > 0 && (
                <div
                  ref={pdfRef}
                  className="answerKeyTable"
                  id="InterviewReport"
                >
                  <table className="table table-bordered text-center border border-dark mb-5">
                    <tbody>
                      {PreExamResult &&
                        PreExamResult.length > 0 &&
                        PreExamResult.map((item, index) => (
                          <>
                            <tr key={index}>
                              <td className="text-left">{item.label}</td>
                              <td className="w-30">{item.data}</td>
                            </tr>
                          </>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
          </div>
          <div
            className={
              stepName === "MainExamResult"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="MainExamResult"
            role="tabpanel"
            aria-labelledby="MainExamResult-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear1"
                          ref={register({ required: true })}
                          // value={selectedYear}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList.map((element, index) => (
                              <option>{element}</option>
                            ))}
                        </select>
                        {_.get("selectedYear1.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>

                      <div className="form-group col-md-5">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo1"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {getmainExamAdvertbyYear &&
                            getmainExamAdvertbyYear.length > 0 &&
                            getmainExamAdvertbyYear
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo1.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>

                      <div className="form-group col-md-4">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam1"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedExam1.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-8">
                        {(session.roleName == "superadmin" ||
                          session.roleName == "secretary" ||
                          session.roleName == "desk officer") && (
                            <>
                              {" "}
                              <button
                                type="reset"
                                className="btn btn-secondary mr-2"
                                onClick={() => onCancelButton()}
                              >
                                {commonLabels.BUTTON_CANCEL}
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                disabled={saveButtonFlag}
                                onClick={(e) => {
                                  onSubmit(e);
                                  setConfirmClicked(true);
                                }}
                              >
                                {commonLabels.BUTTON_VIEW}
                              </button>
                            </>
                          )}
                        {(session.roleName == "superadmin" ||
                          session.roleName == "secretary") && (
                            <button
                              type="button"
                              className="btn btn-primary mr-2"
                              disabled={printFlag || pdfPrintDisabled || !getstatisticaldata.admittedCandidates}
                              onClick={() => {
                                downloadPdf();
                              }}
                            >
                              {commonLabels.BUTTON_PRINT}
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {getstatisticaldata &&
              getstatisticaldata.admittedCandidates >= 0 && (
                <div
                  ref={pdfRef}
                  className="answerKeyTable"
                  id="InterviewReport"
                >
                  <table className="table table-bordered text-center border border-dark mb-5">
                    <tbody>
                      {statisticalTable &&
                        statisticalTable.length > 0 &&
                        statisticalTable.map((item, index) => (
                          <>
                            <tr key={index}>
                              <td className="text-left">{item.label}</td>
                              <td className="w-30">{item.data}</td>
                            </tr>
                          </>
                        ))}
                    </tbody>
                  </table>

                  <table className="table table-bordered text-center border border-dark mt-5">
                    <tbody>
                      {statisTable &&
                        statisTable.length > 0 &&
                        statisTable.map((item, index) => (
                          <>
                            <tr key={index}>
                              <td className="text-left">{item.label}</td>
                              <td className="w-30">{item.data}</td>
                            </tr>
                          </>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
